var React = require('react');

function Collection (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,9.6c0,1.3,0.7,2,2,2h0.3V6.4c0-1.8,1.1-2.9,2.9-2.9h7.7V3.5c0-1.3-0.7-2-2-2H2c-1.3,0-2,0.7-2,2V9.6z M5.3,14.5H14\n\tc1.3,0,2-0.7,2-2v-6c0-1.3-0.7-2-2-2H5.3c-1.3,0-2,0.7-2,2v6C3.2,13.8,3.9,14.5,5.3,14.5z","fill":"currentColor"}));
}

Collection.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Collection;

Collection.default = Collection;
